<app-moniepoint-dialog [dialogType]="'filter'" [className]="'filter'" [icon]="icon">
    <div class="font-bold text-[#000000e6] mt-[8px]"
        [ngClass]="isMobile? 'text-[20px] leading-[24px] mb-[24px] text-center': 'text-[24px] leading-[29px]'">
        Edit {{transactionType}} Limit
    </div>
    <div class="m-t-8">
        <app-floating-label-input [controlDef]="dailyLimitAmountControl" [label]="'Daily '+transactionType+' Limit'"
            [placeHolder]="'Daily '+transactionType+' Limit'">
        </app-floating-label-input>
        <div class="mt-[-15px] flex items-center text-[10px] leading-[14px] font-bold">
            <svg class="mr-[5px]" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016C14.6628 11.6804 11.6804 14.6628 8.00016 14.6668ZM6.66016 7.32683V8.66683H7.32683V11.3335H9.34016V10.0002H8.66683L8.6735 7.3275L6.66016 7.32683ZM7.32683 4.66683V6.01283H8.6735V4.66683H7.32683Z"
                    fill="#0361F0" />
            </svg>
            Max Limit: {{maxDailyLimit | majorAmount | currency:"₦"}}
        </div>
    </div>
    <div *ngIf="isMobile" class="opacity-[0.17] border-[0.6px] border-solid border-primary mt-[32px] mb-[24px]"></div>
    <section [ngClass]="{'grid grid-cols-2 gap-4 mt-[32px]': !isMobile}">
        <div *ngIf="!isMobile" class="w-full"></div>
        <div class="grid grid-cols-2 gap-4 mt-1">
            <div (click)="back()" class="back-btn my-auto">
                Back
            </div>
            <app-custom-submit-button [submitting]="isLoading" [disabled]="form.invalid" (submitForm)="updateDailyTransferLimit()" [block]="true" class="btn btn-block" [name]="'Save'">
            </app-custom-submit-button>
        </div>
    </section>
</app-moniepoint-dialog>

<ng-template #icon>
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.5" cy="22.5" r="22.5" fill="#0361F0" />
        <path
            d="M23.9087 12.7148H16.2726C15.6701 12.7148 15.1817 13.2058 15.1817 13.8114C15.1817 14.417 15.6701 14.908 16.2726 14.908L21.2751 14.908L13.3195 22.9051C12.8935 23.3334 12.8935 24.0277 13.3195 24.4559C13.7455 24.8841 14.4362 24.8841 14.8622 24.4559L22.8178 16.4588L22.8178 21.4874C22.8178 22.093 23.3062 22.5839 23.9087 22.5839C24.5111 22.5839 24.9995 22.093 24.9995 21.4874L24.9995 13.8114C24.9995 13.2058 24.5111 12.7148 23.9087 12.7148Z"
            fill="white" />
        <path
            d="M20.0914 33.2853H27.7275C28.3299 33.2853 28.8183 32.7944 28.8183 32.1888C28.8183 31.5831 28.3299 31.0922 27.7275 31.0922H22.725L30.6805 23.095C31.1066 22.6668 31.1066 21.9725 30.6805 21.5443C30.2545 21.116 29.5638 21.116 29.1378 21.5443L21.1823 29.5414L21.1823 24.5128C21.1823 23.9072 20.6939 23.4162 20.0914 23.4162C19.4889 23.4162 19.0005 23.9072 19.0005 24.5128L19.0005 32.1888C19.0005 32.7944 19.4889 33.2853 20.0914 33.2853Z"
            fill="white" />
    </svg>
</ng-template>